import { useQuery } from '@apollo/client/react';
import { css } from '@emotion/react';
import { Avatar, Box, Theme, Typography } from '@mui/material';
import { addSize } from '@scorenco/core';

import { GetLivePlayerDocument } from '../../EventPostItem.query.generated';

type EventPostActionItemLivePlayerProps = {
  livePlayer: any;
  home: any;
};

export const EventPostActionItemLivePlayer = ({
  livePlayer,
  home,
}: EventPostActionItemLivePlayerProps) => {
  const getOnePlayer = useQuery(GetLivePlayerDocument, {
    variables: {
      livePlayerId: livePlayer,
    },
    skip: !livePlayer,
  });
  const player = getOnePlayer.data?.lives_live_player_by_pk;

  const cs = {
    action: (theme: Theme) => css`
      text-transform: uppercase;
      font-weight: bold;
      font-family: ${theme.typography.fontFamilyAlt};
      margin: 0;
      line-height: 1.2;
    `,
    player: (theme: Theme) => css`
      display: flex;
      border-radius: 0 0 0.25rem 0.25rem;

      overflow: hidden;
      margin-top: -1rem;
      margin-bottom: 1rem;
      padding: 0.5rem 1rem;
      align-items: center;
      justify-content: center;
      background: ${theme.vars.palette.background.default};
      border: 1px solid ${theme.vars.palette.divider};
    `,
  };

  return (
    <Box
      css={cs.player}
      sx={[
        home
          ? {
              backgroundColor: {
                backgroundColor: 'primary.main',
              },
            }
          : {
              backgroundColor: {
                backgroundColor: 'secondary.main',
              },
            },
      ]}
    >
      {player && (
        <>
          <Avatar
            src={
              addSize(player.player_picture || player.player?.photo, 24, 24) ||
              ''
            }
            css={css`
              width: 2rem;
              height: 2rem;
            `}
          />
          <div
            css={css`
              flex: 1;
              margin-left: 0.5rem;
            `}
          >
            <Typography
              sx={{ fontSize: { xs: '0.8rem', md: '1rem' } }}
              css={cs.action}
            >
              {player.number
                ? player.number + ' - ' + player.name
                : player.name}
            </Typography>
          </div>
        </>
      )}
    </Box>
  );
};
